import { FC, useEffect, useState } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import { Card, Col, Image, Row, SimpleCollapse, Span } from 'components'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useAuth, useLoading, useModal, useReportPrint } from 'hooks'
import {
  IHandlePrintConsolidacaoEfetivo,
  IRelatorioAdesaoTotalizadasContent
} from 'hooks/useReportPrint/types'
import { PERMITIONS } from 'permitions'
import {
  EffectiveConsolidationServices,
  IAdhesion,
  ITotalizadoresAndItensAdhesionContent,
  IGetAdesaoTable
} from 'services/NGT/EffectiveConsolidation'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

import { downloadURI } from '../../EffectiveConsolidation'
import { ReportTable } from './components/ReportTable/ReportTable'
import { FormatAdhesionTableData } from './utils/FormatAdhesionTableData'

interface ICollapsesPropsPDF {
  collapseTitle: string
  tableTitle: string
}

interface IReportAdhesionTotalized {
  flRecorrente: boolean
}

const ReportAdhesionTotalized: FC<IReportAdhesionTotalized> = ({ flRecorrente }) => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()
  const { user } = useAuth()
  const { handlePrintAdesaoTotalizadas } = useReportPrint()

  const [isGeneratePDF, setIsGeneratePDF] = useState<boolean>(false)
  const [reportAdhesionByArea, setReportAdhesionByArea] =
    useState<IGetAdesaoTable>()
  const [reportAdhesionByCompany, setReportAdhesionByCompany] =
    useState<IGetAdesaoTable>()
  const [reportAdhesionByExecutive, setReportAdhesionByExecutive] =
    useState<IGetAdesaoTable>()
  const [reportAdhesionByUnit, setReportAdhesionByUnit] =
    useState<IGetAdesaoTable>()

  const collapsesTitles: ICollapsesPropsPDF[] = [
    {
      collapseTitle: 'Distribuição por Diretoria Executiva',
      tableTitle: 'Diretoria Executiva'
    },
    {
      collapseTitle: 'Distribuição por Empresas',
      tableTitle: 'Empresa'
    },
    {
      collapseTitle: 'Distribuição por Área',
      tableTitle: 'Área'
    },
    {
      collapseTitle: 'Distribuição por Unidade de Negócio',
      tableTitle: 'Unidade Negócio'
    }
  ]

  const GenerateExcelAdhesion = async () => {
    setLoading('loading')

    EffectiveConsolidationServices()
      .GetExcelAdesao(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )
      .then((response) => {
        if (response.status === 200) {
          downloadURI(response.data, `adesao-totalizadas.xlsx`)
        }
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem ||
            error.message ||
            'Não foi possivel fazer o download da planilha, tente novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleClickPdfReport = async () => {
    setLoading('loading')

    try {
      setLoading('idle')

      const pdfDataArray: IRelatorioAdesaoTotalizadasContent[] = []
      collapsesTitles.forEach((collapseTitle) => {
        formatTableDataNumbers(reportAdhesionByExecutive, reportAdhesionByArea, reportAdhesionByCompany, reportAdhesionByUnit)
        pdfDataArray.push({
          body:
            collapseTitle.collapseTitle ===
              'Distribuição por Diretoria Executiva'
              ? reportAdhesionByExecutive.itensConsolidacao.map(
                (item: IAdhesion, index) => {
                  const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                  // Criando as listas principais
                  effectiveByExecutiveArray.push([
                    item?.totalizadores?.dsConsolidacao?.toUpperCase() || "" || "",
                    item?.totalizadores.qtMobilizacaoMensal,
                    item?.totalizadores.qtFornecedor,
                    item?.totalizadores.qtContratoPrincipal,
                    item?.totalizadores.qtSubContrato,
                    item?.totalizadores.qtTotalContratos,
                    item?.totalizadores.qtTotalContrapartes,
                    item?.totalizadores.qtContraparteNaoPreencheu,
                    item?.totalizadores.peContrapartes + '%'
                  ])
                  // Adicionando as listas de subItens
                  item.itens.forEach(
                    (subItem: ITotalizadoresAndItensAdhesionContent) =>
                      effectiveByExecutiveArray.push([
                        FORMAT.capitalizeString(
                          subItem?.dsConsolidacao.toLowerCase()
                        ),
                        subItem?.qtMobilizacaoMensal,
                        subItem?.qtFornecedor,
                        subItem?.qtContratoPrincipal,
                        subItem?.qtSubContrato,
                        subItem?.qtTotalContratos,
                        subItem?.qtTotalContrapartes,
                        subItem?.qtContraparteNaoPreencheu,
                        subItem?.peContrapartes + '%'
                      ])
                  )
                  !reportAdhesionByExecutive.itensConsolidacao[index + 1] && effectiveByExecutiveArray.push([
                    "Total",
                    reportAdhesionByExecutive?.total?.qtMobilizacaoMensal,
                    reportAdhesionByExecutive?.total?.qtFornecedor,
                    reportAdhesionByExecutive?.total?.qtContratoPrincipal,
                    reportAdhesionByExecutive?.total?.qtSubContrato,
                    reportAdhesionByExecutive?.total?.qtTotalContratos,
                    reportAdhesionByExecutive?.total?.qtTotalContrapartes,
                    reportAdhesionByExecutive?.total?.qtContraparteNaoPreencheu,
                    reportAdhesionByExecutive?.total?.peContrapartes + '%',
                  ])
                  return effectiveByExecutiveArray
                }
              )
              : collapseTitle.collapseTitle === 'Distribuição por Empresas'
                ? reportAdhesionByCompany.itensConsolidacao.map(
                  (item: IAdhesion, index) => {
                    const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                    // Criando as listas principais
                    effectiveByExecutiveArray.push([
                      item?.totalizadores?.dsConsolidacao?.toUpperCase() || "",
                      item?.totalizadores.qtMobilizacaoMensal,
                      item?.totalizadores.qtFornecedor,
                      item?.totalizadores.qtContratoPrincipal,
                      item?.totalizadores.qtSubContrato,
                      item?.totalizadores.qtTotalContratos,
                      item?.totalizadores.qtTotalContrapartes,
                      item?.totalizadores.qtContraparteNaoPreencheu,
                      item?.totalizadores.peContrapartes + '%'
                    ])
                    // Adicionando as listas de subItens
                    item.itens.forEach(
                      (subItem: ITotalizadoresAndItensAdhesionContent) =>
                        effectiveByExecutiveArray.push([
                          FORMAT.capitalizeString(
                            subItem?.dsConsolidacao.toLowerCase()
                          ),
                          subItem?.qtMobilizacaoMensal,
                          subItem?.qtFornecedor,
                          subItem?.qtContratoPrincipal,
                          subItem?.qtSubContrato,
                          subItem?.qtTotalContratos,
                          subItem?.qtTotalContrapartes,
                          subItem?.qtContraparteNaoPreencheu,
                          subItem?.peContrapartes + '%'
                        ])
                    )
                    !reportAdhesionByCompany.itensConsolidacao[index + 1] && effectiveByExecutiveArray.push([
                      "Total",
                      reportAdhesionByCompany?.total?.qtMobilizacaoMensal,
                      reportAdhesionByCompany?.total?.qtFornecedor,
                      reportAdhesionByCompany?.total?.qtContratoPrincipal,
                      reportAdhesionByCompany?.total?.qtSubContrato,
                      reportAdhesionByCompany?.total?.qtTotalContratos,
                      reportAdhesionByCompany?.total?.qtTotalContrapartes,
                      reportAdhesionByCompany?.total?.qtContraparteNaoPreencheu,
                      reportAdhesionByCompany?.total?.peContrapartes + '%',
                    ])
                    return effectiveByExecutiveArray
                  }
                )
                : collapseTitle.collapseTitle === 'Distribuição por Área'
                  ? reportAdhesionByArea.itensConsolidacao.map(
                    (item: IAdhesion, index) => {
                      const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                      // Criando as listas principais
                      effectiveByExecutiveArray.push([
                        item?.totalizadores?.dsConsolidacao?.toUpperCase()  || "",
                        item?.totalizadores.qtMobilizacaoMensal,
                        item?.totalizadores.qtFornecedor,
                        item?.totalizadores.qtContratoPrincipal,
                        item?.totalizadores.qtSubContrato,
                        item?.totalizadores.qtTotalContratos,
                        item?.totalizadores.qtTotalContrapartes,
                        item?.totalizadores.qtContraparteNaoPreencheu,
                        item?.totalizadores.peContrapartes + '%'
                      ])
                      // Adicionando as listas de subItens
                      item.itens.forEach(
                        (subItem: ITotalizadoresAndItensAdhesionContent) =>
                          effectiveByExecutiveArray.push([
                            FORMAT.capitalizeString(
                              subItem?.dsConsolidacao.toLowerCase()
                            ),
                            subItem?.qtMobilizacaoMensal,
                            subItem?.qtFornecedor,
                            subItem?.qtContratoPrincipal,
                            subItem?.qtSubContrato,
                            subItem?.qtTotalContratos,
                            subItem?.qtTotalContrapartes,
                            subItem?.qtContraparteNaoPreencheu,
                            subItem?.peContrapartes + '%'
                          ])
                      )
                      !reportAdhesionByArea.itensConsolidacao[index + 1] && effectiveByExecutiveArray.push([
                        "Total",
                        reportAdhesionByArea?.total?.qtMobilizacaoMensal,
                        reportAdhesionByArea?.total?.qtFornecedor,
                        reportAdhesionByArea?.total?.qtContratoPrincipal,
                        reportAdhesionByArea?.total?.qtSubContrato,
                        reportAdhesionByArea?.total?.qtTotalContratos,
                        reportAdhesionByArea?.total?.qtTotalContrapartes,
                        reportAdhesionByArea?.total?.qtContraparteNaoPreencheu,
                        reportAdhesionByArea?.total?.peContrapartes + '%',
                      ])
                      return effectiveByExecutiveArray
                    }
                  )
                  : collapseTitle.collapseTitle ===
                    'Distribuição por Unidade de Negócio'
                    ? reportAdhesionByUnit.itensConsolidacao.map(
                      (item: IAdhesion, index) => {
                        const effectiveByExecutiveArray: (string | number)[][] = [] // Array auxiliar
                        // Criando as listas principais
                        effectiveByExecutiveArray.push([
                          item?.totalizadores?.dsConsolidacao?.toUpperCase()  || "",
                          item?.totalizadores.qtMobilizacaoMensal,
                          item?.totalizadores.qtFornecedor,
                          item?.totalizadores.qtContratoPrincipal,
                          item?.totalizadores.qtSubContrato,
                          item?.totalizadores.qtTotalContratos,
                          item?.totalizadores.qtTotalContrapartes,
                          item?.totalizadores.qtContraparteNaoPreencheu,
                          item?.totalizadores.peContrapartes + '%'
                        ])
                        // Adicionando as listas de subItens
                        item.itens.forEach(
                          (subItem: ITotalizadoresAndItensAdhesionContent) =>
                            effectiveByExecutiveArray.push([
                              FORMAT.capitalizeString(
                                subItem?.dsConsolidacao.toLowerCase()
                              ),
                              subItem?.qtMobilizacaoMensal,
                              subItem?.qtFornecedor,
                              subItem?.qtContratoPrincipal,
                              subItem?.qtSubContrato,
                              subItem?.qtTotalContratos,
                              subItem?.qtTotalContrapartes,
                              subItem?.qtContraparteNaoPreencheu,
                              subItem?.peContrapartes + '%'
                            ])
                        )
                        !reportAdhesionByUnit.itensConsolidacao[index + 1] && effectiveByExecutiveArray.push([
                          "Total",
                          reportAdhesionByUnit?.total?.qtMobilizacaoMensal,
                          reportAdhesionByUnit?.total?.qtFornecedor,
                          reportAdhesionByUnit?.total?.qtContratoPrincipal,
                          reportAdhesionByUnit?.total?.qtSubContrato,
                          reportAdhesionByUnit?.total?.qtTotalContratos,
                          reportAdhesionByUnit?.total?.qtTotalContrapartes,
                          reportAdhesionByUnit?.total?.qtContraparteNaoPreencheu,
                          reportAdhesionByUnit?.total?.peContrapartes + '%',
                        ])
                        return effectiveByExecutiveArray
                      }
                    )
                    : [],
          tableTitle: collapseTitle.tableTitle,
          titleCollapse: collapseTitle.collapseTitle
        })
      })

      if (pdfDataArray) {
        const pdfObject: IHandlePrintConsolidacaoEfetivo = {
          data: pdfDataArray,
          filename: `relatorio-consolidacao-adesao-totalizadas`
        }
        handlePrintAdesaoTotalizadas(pdfObject)
      } else {
        showModal({
          hideButtonCancel: true,
          message: 'Não há efetivo cadastrado para este contrato.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
      }
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message:
          error.mensagem ||
          error.message ||
          'Não foi possivel obter a lista de Efetivos deste contrato',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }

  const HeaderEffectiveConsolidationTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
        <Col justifyContent="center" marginLeft={SPACING.spacing200}>
          <Span
            text="RELATÓRIO ADESÃO TOTALIZADAS"
            color={COLORS.blueFonts}
            fontSize="24px"
            fontWeight={FONTS.bold}
            textTransform="uppercase"
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          />
          <Span
            textAlign="center"
            fontWeight="bold"
            fontSize={TYPOGRAPHY.bodySize16}
            color={COLORS.blueFonts}
            text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
            marginTop={SPACING.spacing15}
            marginBottom={SPACING.spacing15}
          />
        </Col>
      </Row>
    </Card>
  )

  const getReportAdhesion = async () => {
    setLoading('loading')
    try {
      const response = await EffectiveConsolidationServices().GetAdesao(
        user.IdUsuario,
        user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE,
        flRecorrente
      )
      if (response.status !== 200) throw new Error(response.statusText)

      setReportAdhesionByArea(response.data.entity.area)
      setReportAdhesionByCompany(response.data.entity.empresa)
      setReportAdhesionByExecutive(response.data.entity.diretoriaExecutiva)
      setReportAdhesionByUnit(response.data.entity.unidadeNegocio)

      setLoading('idle')
    } catch (error: any) {
      setMsgErro('Erro ao carregar dados do relatório, tente novamente!')
      setLoading('error')
    }
  }

  useEffect(() => {
    getReportAdhesion()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <div id="pdfView">
        {isGeneratePDF ? (
          <HeaderEffectiveConsolidationTitle />
        ) : (
          <>
            <Row
              justifyContent="center"
              marginTop={SPACING.spacing15}
              marginBottom={SPACING.spacing5}
            >
              <Span
                textAlign="center"
                fontWeight="bold"
                fontSize={TYPOGRAPHY.bodySize16}
                color={COLORS.blueFonts}
                text={`${flRecorrente ? "APENAS RECORRENTES - " : ""} Distribuição por DIR EXEC / EMPRESAS / ÁREA / UN NEGÓCIO - do Grupo CSN`}
                marginTop={SPACING.spacing15}
                marginBottom={SPACING.spacing5}
              />
            </Row>
            <Row justifyContent="flex-end">
              <ExcelIcon onClick={() => GenerateExcelAdhesion()} />
              <PdfIcon onClick={() => handleClickPdfReport()} />
            </Row>
          </>
        )}
        <Row marginBottom={SPACING.spacing30} />
        <SimpleCollapse
          title="Distribuição por Diretoria Executiva"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportAdhesionByExecutive}
            titleHeader="Diretoria Executiva"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Empresas"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportAdhesionByCompany}
            titleHeader="Empresa"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Área"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportAdhesionByArea}
            titleHeader="Área"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>

        <SimpleCollapse
          title="Distribuição por Unidade de Negócio"
          isGeneratePDF={isGeneratePDF}
        >
          <ReportTable
            tableData={reportAdhesionByUnit}
            titleHeader="Unidade Negócio"
            isGeneratePDF={isGeneratePDF}
          />
        </SimpleCollapse>
      </div>
    </Card>
  )
}

export default ReportAdhesionTotalized

function formatTableDataNumbers(reportAdhesionByExecutive: IGetAdesaoTable, reportAdhesionByArea: IGetAdesaoTable, reportAdhesionByCompany: IGetAdesaoTable, reportAdhesionByUnit: IGetAdesaoTable) {
  FormatAdhesionTableData.formatarTableData(reportAdhesionByExecutive)
  FormatAdhesionTableData.formatarSubItens(reportAdhesionByExecutive)

  FormatAdhesionTableData.formatarTableData(reportAdhesionByArea)
  FormatAdhesionTableData.formatarSubItens(reportAdhesionByArea)

  FormatAdhesionTableData.formatarTableData(reportAdhesionByCompany)
  FormatAdhesionTableData.formatarSubItens(reportAdhesionByCompany)

  FormatAdhesionTableData.formatarTableData(reportAdhesionByUnit)
  FormatAdhesionTableData.formatarSubItens(reportAdhesionByUnit)

  reportAdhesionByExecutive.total = FormatAdhesionTableData.mapTableDataItem(reportAdhesionByExecutive.total);
  reportAdhesionByArea.total = FormatAdhesionTableData.mapTableDataItem(reportAdhesionByArea.total);
  reportAdhesionByCompany.total = FormatAdhesionTableData.mapTableDataItem(reportAdhesionByCompany.total);
  reportAdhesionByUnit.total = FormatAdhesionTableData.mapTableDataItem(reportAdhesionByUnit.total);
}

